import { Routes } from '@angular/router';
import { LoginComponent } from '@core/auth/login/login.component';
import { LayoutComponent } from '@core/layout/layout.component';
import { authGuard } from '@core/guards/auth.guard';
import { loginGuard } from '@core/guards/login.guard';

import { InContructionPageComponent } from '@shared/components/in-contruction-page/in-contruction-page.component';
import { MaintenancePageComponent } from '@shared/components/maintenance-page/maintenance-page.component';
import { MfaLoginComponent } from '@core/auth/mfa-login/mfa-login.component';
import { RecoverPasswordComponent } from '@core/auth/recover-password/recover-password.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'mfa-login',
    component: MfaLoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
    canActivate: [loginGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        data: { module: 'dashboard.title' },
        loadChildren: () =>
          import('@features/dashboard/dashboard.routes').then(
            (r) => r.dashboardRoutes
          ),
      },
      {
        path: 'companies',
        data: { module: 'company.title' },
        loadChildren: () =>
          import('@features/company/company.routes').then(
            (r) => r.companyRoutes
          ),
      },
      {
        path: 'users',
        data: { module: 'users.title' },
        loadChildren: () =>
          import('@features/users/users.routes').then((r) => r.usersRoutes),
      },
      {
        path: 'administrators',
        data: { module: 'administrators.title' },
        loadChildren: () =>
          import('@features/administrators/administrators.routes').then(
            (r) => r.administratorsRoutes
          ),
      },
      {
        path: 'study-groups',
        data: { module: 'studyGroups.title' },
        loadChildren: () =>
          import('@features/study-groups/study-groups.routes').then(
            (r) => r.studyGroupsRoutes
          ),
      },
      {
        path: 'profiles',
        data: { module: 'profiles.title' },
        loadChildren: () =>
          import('@features/profiles/profiles.routes').then(
            (r) => r.profilesRoutes
          ),
      },
      {
        path: 'reports',
        data: { module: 'reports.title', hasOwnView: false },
        loadChildren: () =>
          import('@features/reports/reports.routes').then(
            (r) => r.reportsRoutes
          ),
      },
      {
        path: 'modules-management',
        data: { module: 'modulesManagement.title' },
        loadChildren: () =>
          import('@features/modules-management/modules-management.routes').then(
            (r) => r.modulesManagementRoutes
          ),
      },
      {
        path: 'courses',
        data: { module: 'courses.title' },
        loadChildren: () =>
          import('@features/courses/courses.routes').then(
            (r) => r.coursesRoutes
          ),
      },
      {
        path: 'countries',
        data: { module: 'countries.title' },
        loadChildren: () =>
          import('@features/countries/countries.routes').then(
            (r) => r.countriesRoutes
          ),
      },
      {
        path: 'notifications',
        data: { module: 'Notificaciones', hasOwnView: false },
        loadChildren: () =>
          import('@features/notifications/notifications.routes').then(
            (r) => r.notificationsRoutes
          ),
      },
      {
        path: 'terms-and-conditions',
        data: { module: 'termsAndConditions.title' },
        loadChildren: () =>
          import('@features/terms-and-conditions/terms-and-conditions.routes').then(
            (r) => r.termsAndConditionsRoutes
          ),
      },
      {
        path: 'learning-paths',
        data: { module: 'learningPaths.title' },
        loadChildren: () =>
          import('@features/learning-paths/learning-paths.routes').then(
            (r) => r.learningPathsRoutes
          ),
      },
      {
        path: 'forms-settings',
        data: { module: 'formsSettings.title' },
        loadChildren: () =>
          import('@features/forms-settings/forms-settings.routes').then(
            (r) => r.formsSettingsRoutes
          ),
      },
      {
        path: 'certificate-templates',
        data: { module: 'certificateTemplates.title' },
        loadChildren: () =>
          import('@features/certificate-templates/certificate-templates.routes').then(
            (r) => r.certificateTemplatesRoutes
          ),
      },
      {
        path: 'certificate-scopes',
        data: { module: 'certificateScopes.assignTitle' },
        loadChildren: () =>
          import('@features/certificate-scopes/certificate-scopes.routes').then(
            (r) => r.certificateScopesRoutes
          ),
      },
      {
        path: 'certificate-regeneration',
        data: { module: 'certificateRegeneration.title' },
        loadChildren: () =>
          import('@features/certificate-regeneration/certificate-regeneration.routes').then(
            (r) => r.certificateRegenerationRoutes
          ),
      },
    ],
  },
  {
    path: 'construction',
    component: InContructionPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
